module.exports = __webpack_public_path__ + "static/media/codeKingOfTheHill.0144666f.png";